import { useQuery } from '@tanstack/react-query';

import { useHasAccess } from '../hooks/useHasAccess';

export const useAllSubdivisions = () => {
  const queryKey = ['subDivisioins'];

  const path = process.env.REACT_APP_STATIC_PATH || '';

  const hasAccess = useHasAccess();

  const queryFn = (): Promise<any> => {
    // we use data from public api
    // https://iso3166-2-api.vercel.app/api/all
    return fetch(`${path}/iso/allSubdivisionData.json`).then(
      (r) => r.json(),
      () => [],
    );
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled: hasAccess,
  });
};
